export enum ReinitActionTypes {
    APP_REINIT = "APP_REINIT",
}

export interface ReInit {
    type: ReinitActionTypes.APP_REINIT;
}

export const reInit: ReInit = {
    type: ReinitActionTypes.APP_REINIT,
};
